"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.downloadFile = void 0;
const downloadFile = async (url, fileName) => {
    try {
        const response = await fetch(url, {
            mode: "cors",
        });
        const blob = await response.blob();
        const blobUrl = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = blobUrl;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(blobUrl);
        return true;
    }
    catch (error) {
        console.error("Error fetching the file:", error);
        return false;
    }
};
exports.downloadFile = downloadFile;
